<header class="header">
    <div class="header-grp">
        <div class="icon" (click)="goBackToPrevPage()">
            <i class="ti ti-chevron-left"></i>
        </div>
        <div class="title">
            <h3>આમંત્રિત સભ્ય</h3>
        </div>
    </div>
</header>
<main>
    <div class="city-search">
        <div class="filtering">
            <form>
                <input type="search" class="form-control" #filter (keyup)="applyFilter($event)" placeholder="શોધો.." />
                <i class="ti ti-search"></i>
            </form>
            <span (click)="goToSendInvitation()" class="cursorClass"><i class="ti ti-plus"
                    *ngIf="userTypeId == 1"></i></span>
        </div>
    </div>
    <mat-tab-group mat-stretch-tabs="true" mat-align-tabs="center" [(selectedIndex)]="selectedTabIndex"
        (selectedIndexChange)="onTabChanged($event)">
        <mat-tab label="આમંત્રિત સભ્યો">
            <div class="main-members family-tabs">
                <a *ngFor="let member of getInvitedMemberList" class="member-list-item">
                    <div>
                        <div class="d-flex align-items-center justify-content-between">
                            <h5>{{ member.member_name}}</h5>
                            <!-- <button mat-icon-button color="primary" matTooltip="આમંત્રણ હાજરી માટે QR કોડ સ્કેન કરો"
                                (click)="showQr(member.user_id)">
                                <mat-icon aria-hidden="false">qr_code</mat-icon>
                            </button> -->
                            <mat-slide-toggle [(ngModel)]="member.is_active" class="example-margin" 
                            [color]="member.is_active == 1? 'green' : 'red' " (change)="openDialog($event,member)">
                        </mat-slide-toggle>
                        </div>
                    </div>
                    
                </a>
            </div>
        </mat-tab>

        <mat-tab label="હાજર સભ્યો" *ngIf="userTypeId == 1">
            <div class="main-members family-tabs">
                <div *ngFor="let member of getPresentMember" class="mb-4 pb-3 border-bottom">
                    <h5>{{ member.member_name }}</h5>
                    <small class="text-success">હાજર તારીખ અને સમય : {{member.attendance_time | date: 'dd/MM/yyyy hh:mm:ss'}} </small>
                </div>
            </div>
        </mat-tab>
    </mat-tab-group>
</main>